<div class="mt-5">
	<div class="br-message danger" role="alert">
		<div class="icon"><i class="fas fa-times-circle fa-lg" aria-hidden="true"></i></div>
		<div class="content">
			<strong>Erro</strong>
			<p>Você não possui acesso a esta funcionalidade. Fale com o seu gestor caso precise de autorização.</p>
		</div>
	</div>
</div>
